import React, { useState, useEffect } from "react"
import { getVideo } from "../../../services/formService"
import ReactPlayer from "react-player/lazy"
import CustomLoader from "../../common/Loader"

const VideoViewer = ({Widget_ID, Form_ID, PrimaryKey, Project_ID}) => {
    const [videoTitle, setVideoTitle] = useState('')
    const [videoUrl, setVideoUrl] = useState('')
    const [loading, setLoading] = useState(true)

    useEffect(() => {
        const getVideoData = async() => {
            const { data } = await getVideo(Widget_ID);
            if (data.length !== 0) {
                setVideoTitle(data[0].Title_Text || '')
                setVideoUrl(data[0].Video_URL || '')
            }
        }
        getVideoData()
        .then(() => setLoading(false))
        // eslint-disable-next-line
    }, [])

    if (loading) {
        return <CustomLoader loading={loading} />
    }

    return <div className='col'>
            {videoTitle}
            <div className='video' style={{overflow: 'auto'}}>
                <ReactPlayer url={videoUrl} controls={true}/>
            </div>
    </div>
}

export default VideoViewer